import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import { useLocation, useParams } from "react-router-dom";
import moment from "moment";
import Dropdown from "react-bootstrap/Dropdown";
import Tooltip from "@mui/material/Tooltip";
import {
  SortIcon,
  AZIcon,
  OldSortIcon,
  ZAIcon,
  CloseIcon,
  EyeIcon,
  DownloadIcon,
  PrintIcon,
  SpinnerIcon,
} from "../../../../assets/icons/iconshere";
import { CancelIcon, SearchesCIcon } from "../../../../SvgIconsData";
import NoCertificates from "../../NoData/NoCertificates";
import Filter from "../../../Filter/Filter";
import { certificateDownload } from "../../../../utils/useWindowDimensions";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { exportMultipleChartsToPdf,generateExcel } from "../../../../utils/pdf";
import { EXLDownloadIcon, PDFDownloadIcon } from "../../../../SvgIconsData";
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import ProPopup from "../../../layouts/ProPopup";



const Certificates = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const appData = useSelector((state) => state.applicationSlice);
  let allTags = appData?.tags?.data?.children?.filter((e) => e?.name != "Sectors") || [];
  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
  const params = useParams();
  const location = useLocation();
  let userUUID = params.userUUID;
  const userData = useSelector((state) => state.userSlice);
  const configData = useSelector((state) => state.configSlice);
  const [listFound, setListFound] = useState(false);
  const [list, setList] = useState([]);
  const [search, setSearch] = useState("");
  const [spinnerIndex, setSpinnerIndex] = useState([]);
  const [userPlan, setUserPlan] = useState(null);
  const [pdfSpinner, setPdfSpinner] = useState(false);
  const [openPro, setOpenPro] = useState(false);
  const [selectedCategoryCheckboxes, setSelectedCategoryCheckboxes] = useState([]);
  const [shorting, setShorting] = useState({
    status: true,
    value: (b, c) => new Date(c.createdAt) - new Date(b.createdAt),
    type: 1,
  });

  let MODE = configData.config.MODE;

  useEffect(() => {
    userData?.plans?.data && setUserPlan(userData.plans.data);
  }, [userData]);

  useEffect(() => {
    userPlan && !userPlan.report.group && setOpenPro(true);
  }, [userPlan]);

  const selectedTags = selectedCheckboxes.map((item) => item.id);
  const handleDropdownToggle = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const getCertificateList = async () => {
    try {
      setListFound(false);
      let { data } = await axios.get(
        `${configData.config.API_URL}/api/dashboard/certificates/${MODE}/${userUUID}`, {
          headers: {
            Authorization: `Bearer ${userData.token}`,
            "Content-Type": "application/json",
          },
          params:{
            applicationId: configData?.config?.applicationId || null
          }
        }
      );

      setList([...data.list]);
    } catch (error) {
      console.log(error);
    } finally {
      setListFound(true);
    }
  };

  useEffect(() => {
    getCertificateList();
  }, [userUUID]);

  const handleCertificateDownload = async (e) => {

    if(spinnerIndex.includes(e.resourceId.uuid)) return;
    
    setSpinnerIndex((preState) => [...preState, e.resourceId.uuid]);
    await certificateDownload({
      certificate: e,
      certificateData: configData.config,
      moduleName: e.resourceId.name,
      userData: userData.user,
      outcomesData: e.resourceId.versions[0].data.outcomesPoints,
      courseDuration: e.resourceId.versions[0].data.courseDuration,
      certificateConfig : userData.certificate
    });

    setSpinnerIndex((preState) => preState.filter(id => id !== e.resourceId.uuid));

  };

  const handleCancelTag = (item) => {
    setSelectedCheckboxes((prevSelected) => prevSelected.filter((selectedItem) => selectedItem !== item));
    setSelectedCategoryCheckboxes((prevSelected) => prevSelected.filter((selectedItem) => selectedItem !== item));
  };

  const filterCourses = (e) => {
    if (search.length && !e.resourceId.name.toLowerCase().includes(search.toLowerCase())) return false;
    const tags = e?.resourceId?.tags?.map((e) => e.id) || [];
    const tagCategory = e.resourceId.tagCategory.map((e) => e.id);
    if (selectedTags.length && !selectedTags.every((element) => tags.includes(element))) return false;
    if (selectedCategoryCheckboxes.length && !selectedCategoryCheckboxes.some((checkbox) => tagCategory.includes(checkbox.id)) ) return false;
    return true;
  };

  let filterList = list.filter(filterCourses);
  shorting.status && filterList.sort(shorting.value);

  const arr = [];

  filterList.map((e) => {
    let name = e.resourceId.name;
    let generatedAt = moment(e.createdAt).format("lll");
    arr.push([name, generatedAt]);
  });

  const tableData1 = [
    ["My Certificates", ""],
    ["Name", userData.user.name],
    ["Report Generated at", moment().format("lll")],
  ];

  const tableData2 = [["Project Name", "Certificate Generated at"], ...arr];


  const handleClickPdfDownload = async(name, table1, table2) => {
    setPdfSpinner(true);
    await exportMultipleChartsToPdf(name, table1, table2)
    setTimeout(()=>setPdfSpinner(false), 500)
  }


  return (
    <>
      <div className="container-fluid p-4 bg-grey-main">
        <>
          <div className="divforrepo mt-0">
            <div className="printnall"></div>
            <div>
              <form className=" app-search app-search1 d-flex justify-content-end ">
                <div className="position-relative">
                  <SearchesCIcon />
                  {search.length > 0 && (
                    <span className="searchiconcancel" onClick={() => setSearch("")}>
                      <CancelIcon />
                    </span>
                  )}

                  <input
                    type="text"
                    value={search}
                    name="searchName"
                    className="form-control"
                    placeholder="Search"
                    autoComplete="off"
                    onChange={(e) => setSearch(e.target.value)}
                  />
                </div>
              </form>

              <Filter
                selectedCheckboxes={selectedCheckboxes}
                setSelectedCheckboxes={setSelectedCheckboxes}
                filterOptions={allTags}
                categoryOptions={appData?.categoryList?.data || null}
                selectedCategoryCheckboxes={selectedCategoryCheckboxes}
                setSelectedCategoryCheckboxes={setSelectedCategoryCheckboxes}
              />

              <Dropdown show={dropdownOpen} onToggle={handleDropdownToggle}>
                <Dropdown.Toggle
                  id="dropdown-basic"
                  className="createbtn"
                  style={{ width: "40px" }}>
                  {shorting.type == 1 ? (
                    <SortIcon />
                  ) : shorting.type == 2 ? (
                    <OldSortIcon />
                  ) : shorting.type == 3 ? (
                    <AZIcon />
                  ) : (
                    <ZAIcon />
                  )}
                </Dropdown.Toggle>
                <Dropdown.Menu className="sidebartopbar modulelistoptions sort">
                  <div className="listoptionsmodule">
                    <p
                      className={shorting.status && shorting.type == 1 ? "active" : ""}
                      onClick={() => {
                        setShorting({
                          status: true,
                          value: (b, c) => new Date(c.createdAt) - new Date(b.createdAt),
                          type: 1,
                        });
                        setDropdownOpen(false);
                      }}>
                      {" "}
                      Latest{" "}
                    </p>
                    <p
                      className={shorting.status && shorting.type == 2 ? "active" : ""}
                      onClick={() => {
                        setShorting({
                          status: true,
                          value: (b, c) => new Date(b.createdAt) - new Date(c.createdAt),
                          type: 2,
                        });
                        setDropdownOpen(false);
                      }}>
                      {" "}
                      Oldest{" "}
                    </p>
                    <p
                      className={shorting.status && shorting.type == 3 ? "active" : ""}
                      onClick={() => {
                        setShorting({
                          status: true,
                          value: (b, c) => b.resourceId.name.localeCompare(c.resourceId.name),
                          type: 3,
                        });
                        setDropdownOpen(false);
                      }}>
                      {" "}
                      Name ( A to Z){" "}
                    </p>
                    <p
                      className={shorting.status && shorting.type == 4 ? "active" : ""}
                      onClick={() => {
                        setShorting({
                          status: true,
                          value: (b, c) => c.resourceId.name.localeCompare(b.resourceId.name),
                          type: 4,
                        });
                        setDropdownOpen(false);
                      }}>
                      {" "}
                      Name ( Z to A){" "}
                    </p>
                  </div>
                </Dropdown.Menu>
              </Dropdown>

              <button
                className="DefaultRedBtn download px-2"
                title="Download PDF"
                onClick={() => userPlan?.myCertificate?.download ? handleClickPdfDownload("Certificate", tableData1, tableData2) : setOpenPro(true) }>
                {pdfSpinner ? <SpinnerIcon /> : <PDFDownloadIcon />}
              </button>
            </div>
          </div>
          <div className="row mt-2 ">
            {[...selectedCheckboxes, ...selectedCategoryCheckboxes].length > 0 && (
              <div className="filerlist mt-3">
                <span>Filters:</span>
                {[...selectedCheckboxes, ...selectedCategoryCheckboxes].map((f) => {
                  return (
                    <span className="filtertag">
                      {f.name}
                      <span onClick={() => handleCancelTag(f)}>
                        <CloseIcon />
                      </span>
                    </span>
                  );
                })}
                <span
                  className="filtertag clear"
                  onClick={() => setSelectedCheckboxes([])}
                  style={{ cursor: "pointer" }}>
                  Clear all
                </span>
              </div>
            )}

            <div className="table-responsive workflowtb mt-2 ">
              <table className="table align-middle table-nowrap mb-0">
                <thead>
                  <tr>
                    <th>
                      {" "}
                      <div className="ps-2 selecthere">S.No.</div>{" "}
                    </th>
                    <th>Project Name</th>
                    <th className="text-center">Generated at</th>
                    <th style={{ textAlign: "center" }}>Actions</th>
                  </tr>
                </thead>
                {listFound ? (
                  filterList.length > 0 ? (
                    <tbody>
                      {filterList.map((e, index) => (
                        <tr key={index}>
                          <td>
                            {" "}
                            <div className="ps-0 selecthere"> {index + 1} </div>{" "}
                          </td>
                          <td> {e.resourceId.name} </td>
                          <td className="text-center">
                            {" "}
                            {moment(e.createdAt).format("DD-MM-YYYY")}{" "}
                          </td>
                          <td className="d-flex align-items-center justify-content-center">
                            <div
                              style={{ width: "fit-content" }}
                              className="d-flex align-items-center justify-content-start gap-3 actionbtns ms-2 ">
                              <Tooltip title= {spinnerIndex.includes(e.resourceId.uuid) ? "Downloading" : "Download" } >
                                <button onClick={() => userPlan?.myCertificate?.download ? handleCertificateDownload(e) : setOpenPro(true) }>
                                  {spinnerIndex.includes(e.resourceId.uuid) ?   <SpinnerIcon /> : <DownloadIcon /> }
                                </button>
                              </Tooltip>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  ) : (
                    <div className="d-flex align-items-center justify-content-center w-100">
                      <NoCertificates />
                    </div>
                  )
                ) : (
                 <>
                  <tbody>
                        <tr >
                          <td>
                          <Skeleton width="5vw"/>   
                          </td>
                          <td>
                          <Skeleton width="15vw"/>
                             </td>
                          <td className="text-center">
                          <Skeleton width="10vw"/>
                          </td>
                          <td className="d-flex align-items-center justify-content-center">
                          <Skeleton width="5vw"/>
                          </td>
                        </tr>
                        <tr >
                          <td>
                          <Skeleton width="5vw"/>   
                          </td>
                          <td>
                          <Skeleton width="15vw"/>
                             </td>
                          <td className="text-center">
                          <Skeleton width="10vw"/>
                          </td>
                          <td className="d-flex align-items-center justify-content-center">
                          <Skeleton width="5vw"/>
                          </td>
                        </tr>
                        <tr >
                          <td>
                          <Skeleton width="5vw"/>   
                          </td>
                          <td>
                          <Skeleton width="15vw"/>
                             </td>
                          <td className="text-center">
                          <Skeleton width="10vw"/>
                          </td>
                          <td className="d-flex align-items-center justify-content-center">
                          <Skeleton width="5vw"/>
                          </td>
                        </tr>
                        <tr >
                          <td>
                          <Skeleton width="5vw"/>   
                          </td>
                          <td>
                          <Skeleton width="15vw"/>
                             </td>
                          <td className="text-center">
                          <Skeleton width="10vw"/>
                          </td>
                          <td className="d-flex align-items-center justify-content-center">
                          <Skeleton width="5vw"/>
                          </td>
                        </tr>
                    </tbody>
                 </>
                )}
              </table>
            </div>
          </div>
        </>
      </div>
      <ProPopup openPro={openPro} setOpenPro={setOpenPro} />
    </>
  );
};
export default Certificates;
